<template>
    <div>
        <div v-if="website" class="flex justify-start items-center py-1 gap-2 w-full">
            <img class="w-[50px] h-[50px] rounded-lg border border-gray-200" :src="logo" />
            <div class="w-56">
                <p class="font-semibold">{{ name }}</p>
                <a v-if="formattedRetailerWebsite != null" :href="formattedRetailerWebsite" class="underline text-gray-600 text-[11px]" target="blank_">
                    {{ website }}
                </a>
                <p class="text-gray-600 text-[11px]">{{ labels }}</p>
            </div>
        </div>
        <div v-else class="flex justify-start items-center py-1 gap-2 font-medium w-full">
            <img class="w-[50px] h-[50px] rounded-lg" :src="logo" />
            <div class="w-56">
                <p class="font-semibold">{{ name }}</p>
                <p class="text-gray-600 text-[11px]">{{ labels }}</p>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name:"Enriched-Merchant",
	components:{
	},
	props:{
		logo:{
			type:String
		},	
		name:{
			type:String
		},
        website:{
			type:String
		},
        labels:{
            type:String
        }
	},
	data(){
		return{

		}
	},
    computed: {
        formattedRetailerWebsite() {
            if(this.website == null)
            {
                return null
            }
            // Check if retailerWebsite starts with "https://" or "http://"
            if (this.website.startsWith('https://') || this.website.startsWith('http://')) {
                return this.website;
            } else {
                // If it doesn't, add "https://" prefix
                return `https://${this.website}`;
            }
        }

    },
	mounted(){

	}

}
</script>

<style>

</style>